module.exports = __webpack_public_path__ + "img/full7-min.79dd0ee6.png";